/**
 * Componente: Login
 * Página de inicio de sesión
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuthContext();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login(username, password);

      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.error || 'Usuario o contraseña incorrectos');
      }
    } catch (err) {
      setError('Error al iniciar sesión. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">💳 Monedero Digital NFC</h1>
        <p className="login-subtitle">Sistema de Pagos Estudiantil</p>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              <span>⚠️ {error}</span>
            </div>
          )}

          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingresa tu usuario"
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingresa tu contraseña"
              required
              disabled={loading}
            />
          </div>

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>

        <div className="login-demo-info">
          <div className="demo-header">
            <span className="demo-icon">👤</span>
            <strong>Usuarios de Prueba</strong>
          </div>
          <div className="demo-credentials">
            <div className="credential-item">
              <span className="credential-label">Usuario:</span>
              <code className="credential-value">cafeteria</code>
            </div>
            <div className="credential-item">
              <span className="credential-label">Contraseña:</span>
              <code className="credential-value">password</code>
            </div>
          </div>
          <div className="demo-divider"></div>
          <div className="demo-credentials">
            <div className="credential-item">
              <span className="credential-label">Usuario:</span>
              <code className="credential-value">papeleria</code>
            </div>
            <div className="credential-item">
              <span className="credential-label">Contraseña:</span>
              <code className="credential-value">password</code>
            </div>
          </div>
          <div className="demo-note">
            <span className="note-icon">💡</span>
            <span>Usa estos usuarios para explorar el sistema</span>
          </div>
        </div>

        <div className="login-footer">
          <div className="footer-links">
            <a href="https://github.com" target="_blank" rel="noopener noreferrer">
              📚 Documentación
            </a>
            <span className="footer-separator">•</span>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer">
              ℹ️ Ayuda
            </a>
          </div>
          <small className="footer-version">v1.0.0 | 2026</small>
        </div>
      </div>
    </div>
  );
};

export default Login;
